import { FullscreenToggle } from "./components/FullscreenToggle";
import { HeaderSettingsMenu } from "./components/HeaderSettingsMenu";
import { UserMenu } from "./components/UserMenu";
import { NotificationBell } from "@/modules/notifications";
import { SearchBar } from "@/modules/search";
import { SearchMobileButton } from "@/modules/search/components/SearchMobileButton";
import { useSidebar } from "@/modules/dashboard-shell/SidebarProvider";
import { ChevronLeft, Menu } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";

export function Header() {
  const { t } = useTranslation();
  const { isOpen, toggle } = useSidebar();

  return (
    <header className="dashboard-header sticky top-0 z-30 shrink-0 border-b border-border/60 bg-card px-3 py-3 shadow-[var(--shadow-sm)] sm:px-4 sm:py-3.5 lg:px-8 lg:py-4">
      <div className="flex items-center gap-2 sm:gap-3">
        <button
          type="button"
          onClick={toggle}
          aria-label={isOpen ? t.header.closeSidebar : t.header.menu}
          aria-expanded={isOpen}
          className="rhythm-icon-btn shrink-0"
        >
          {isOpen ? (
            <ChevronLeft size={20} strokeWidth={1.75} />
          ) : (
            <Menu size={20} strokeWidth={1.75} />
          )}
        </button>

        <SearchMobileButton />

        <div className="hidden min-w-0 flex-1 md:flex lg:justify-center">
          <SearchBar className="w-full max-w-xl" />
        </div>

        <div className="ml-auto flex shrink-0 items-center gap-1 sm:gap-2">
          <div className="hidden sm:contents">
            <FullscreenToggle />
          </div>
          <NotificationBell />
          <HeaderSettingsMenu />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
